



































import { defineComponent, PropType } from "@vue/composition-api";
import { Reservation } from "@/swagger/models";

export default defineComponent({
    name: "sidebarReservation",
    components: {},
    props: {
        reservation: Object as PropType<Reservation>,
        future: Boolean,
    },
    setup(props, ctx) {},
});
